import { render, staticRenderFns } from "./ChatLoader.vue?vue&type=template&id=bd23cbfe&"
import script from "./ChatLoader.vue?vue&type=script&lang=js&"
export * from "./ChatLoader.vue?vue&type=script&lang=js&"
import style0 from "./ChatLoader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports